export default __webpack_public_path__ + "3d512c7c1919deea68e989de569318b0.svg";